import firebase from "firebase";

var firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDXvAUcQ8cDuWT_8_rk8Zq7oRDR_hc3Ijw",
    authDomain: "portfolio-data-44b04.firebaseapp.com",
    databaseURL: "https://portfolio-data-44b04-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "portfolio-data-44b04",
    storageBucket: "portfolio-data-44b04.appspot.com",
    messagingSenderId: "572441748143",
    appId: "1:572441748143:web:b2277011f2e8f140746a5a"

});

var db = firebaseApp.firestore();

export { db };